
import {defineComponent} from "vue";
import {mapActions, mapGetters} from "vuex";
import {
  PagedProductSelectionOverviewRestDto,
} from "@/api/pharma-cpc-mgmt/models";
import {formatIntlNumber} from '@/helpers/functions/intl-format';
import BaseCard from "@/components/UI/Bootstrap/Card/BaseCard.vue";
import BaseCardHeader from "@/components/UI/Bootstrap/Card/BaseCardHeader.vue";
import BaseCardBody from "@/components/UI/Bootstrap/Card/BaseCardBody.vue";
import BasePagination from "@/components/UI/Bootstrap/BasePagination.vue";
import ProductSelectionProductsSelectionItem
  from "@/components/layouts/catalog/product-selection/ProductSelectionProductsSelectionItem.vue";
import {arrayHasContent} from "@/helpers/functions/arrays";
import {SelectionTypeEnum} from "@/api/enums/selection-type-enum";

export default defineComponent({
  name: "ProductSelectionProductsSelection",
  components: {
    BasePagination,
    BaseCardBody,
    BaseCardHeader,
    BaseCard,
    ProductItem: ProductSelectionProductsSelectionItem
  },
  emits: ["updateProductItem", "updatedPage", "openOffCanvasProductDetail"],
  props: {
    filterSelectionTypeCode: {
      type: String,
      required: false,
      default: undefined,
    },
    isReady: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('cpc_mgmt', ['getProductSelectionProducts']),
    productSelectionOverview(): PagedProductSelectionOverviewRestDto {
      return this.getProductSelectionProducts(this.filterSelectionTypeCode);
    },
    hasProducts(): boolean {
      return arrayHasContent(this.productSelectionOverview.results);
    },
    itemsCountText(): String {
      const itemLabel = (this.productSelectionOverview.paging_metadata?.total_elements === 1) ? this.$t('item') : this.$t('items');
      return `${formatIntlNumber(this.productSelectionOverview.paging_metadata?.total_elements ?? 0, this.$i18n.locale)} ${itemLabel.toLowerCase()}`;
    },
    title(): Object {
      switch (this.filterSelectionTypeCode) {
        case SelectionTypeEnum.BASE_SELECTION:
          return {name: 'followBaseSelection', icon: 'B', btnClass: 'btn-warning'};
        case SelectionTypeEnum.INCLUDE:
          return {name: 'doFollow', icon: '+', btnClass: 'btn-secondary'};
        case SelectionTypeEnum.EXCLUDE:
          return {name: 'doNotFollow', icon: '-', btnClass: 'btn-danger'};
        case undefined:
          return {name: 'allProducts', icon: 'A', btnClass: 'btn-dark'};
        default:
          throw new Error('Unsupported filterSelectionTypeCode to map ' + this.filterSelectionTypeCode);
      }
    },
  },
  methods: {
    ...mapActions('cpc_mgmt', ['setCurrentPage']),
    updatePage(page: number) {
      this.setCurrentPage({
        filter_selection_type_code: this.filterSelectionTypeCode,
        page: page,
        type: 'PRODUCT'
      })
      this.$emit('updatedPage', page);
    },
    updateProductItem(product_code: string, selection_type_code: SelectionTypeEnum) {
      this.$emit('updateProductItem', product_code, selection_type_code);
    },
  }
});
